import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  private appOverlay = new BehaviorSubject<boolean>(false);

  isVisible(): Observable<boolean> {
    return this.appOverlay.asObservable();
  }

  show() {
    this.appOverlay.next(true);
  }

  hide() {
    this.appOverlay.next(false);
  }
}
